(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/eid-sign/assets/javascripts/observablemodel.js') >= 0) return;  svs.modules.push('/components/app/eid-sign/assets/javascripts/observablemodel.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const observableModel = svs => {
  'use strict';

  class ObservableModel {
    constructor() {
      let initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.state = _objectSpread({}, initialState);
      this.listeners = {};
    }
    set(keyOrObj, value) {
      if (typeof keyOrObj === 'object') {
        Object.keys(keyOrObj).forEach(key => this._setKey(key, keyOrObj[key]));
      } else {
        this._setKey(keyOrObj, value);
      }
    }
    _setKey(key, value) {
      const oldValue = this.state[key];
      if (oldValue === value) return; 
      this.state[key] = value;
      if (this.listeners[key]) {
        this.listeners[key].forEach(listener => listener(this, value, oldValue));
      }
    }
    get(key) {
      return this.state[key];
    }
    once(event, callback) {
      const wrapper = (model, value, oldValue) => {
        this.off(event, wrapper);
        callback(model, value, oldValue);
      };
      this.on(event, wrapper);
    }
    on(event, callback) {
      if (!this.listeners[event]) this.listeners[event] = [];
      this.listeners[event].push(callback);
    }
    off(event, callback) {
      if (!this.listeners[event]) return;
      this.listeners[event] = this.listeners[event].filter(fn => fn !== callback);
    }
  }
  svs.app.eidSign.ObservableModel = ObservableModel;
};
observableModel(svs);

 })(window);